<template>
    <div class="screen">
        <div class="screen-banner"></div>
        <div class="screen-left">
            <div class="screen-piece">
                <div class="screen-piece-title">
                    <img src="../../screen/image/approve-icon.png" class="piece-title-icon"/>
                    <div class="piece-title-text">审批统计</div>
                </div>
                <div class="approve-data">
                    <div class="approve-data-item">
                        <div class="approve-data-title">累计审批</div>
                        <div class="approve-data-num">{{approveData.total}}</div>
                    </div>
                    <div class="approve-data-item">
                        <div class="approve-data-title">待审批</div>
                        <div class="approve-data-num">{{approveData.prev}}</div>
                    </div>
                </div>
                <div class="approve-data-list">
                    <div class="list-title">
                        <div class="list-title-icon"></div>
                        <div class="list-title-text">TOP5</div>
                    </div>
                    <div class="data-list-area">
                        <div class="data-list-item" v-for="(a, i) in approveData.topList" :key="i">
                            <div class="data-list-title detail-link" @click="goDetail(`/temp/${a.id}/data`)">{{a.name}}</div>
                            <div class="data-list-num">
                                <div class="data-num-bar" :class="[`bar-${i}`]" :style="{width: a.width}"></div>
                                <div class="data-num-text" :style="{width: approveData.nw}">{{a.count}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="screen-piece">
                <div class="screen-piece-title">
                    <img src="../../screen/image/buddha-icon.png" class="piece-title-icon"/>
                    <div class="piece-title-text">活动法会</div>
                </div>
                <div class="buddha-area">
                    <div class="buddha-data">
                        <div class="buddha-data-item">
                            <div class="buddha-data-title detail-link" @click="goDetail('/temp/act/data')">活动</div>
                            <div class="buddha-data-num">{{buddhaData.total}}</div>
                        </div>
                        <div class="buddha-data-item">
                            <div class="buddha-data-title detail-link" @click="goDetail('/buddha/bc')">法会</div>
                            <div class="buddha-data-num">{{buddhaData.prev}}</div>
                        </div>
                    </div>
                    <div class="buddha-table-title detail-link" @click="goDetail('/oa/calendar')">通告</div>
                    <div class="buddha-notice-area">
                        <div class="buddha-tale-box" v-for="(t, index) in buddhaData.noticeList" :key="index">
                            <table>
                                <thead>
                                <tr>
                                    <th>活动名称</th>
                                    <th>倒计时（天）</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr :class="{back: i % 2 == 0}" v-for="(l, i) in t" :key="i" v-show="l.day > 0">
                                    <td :title="l.name">{{l.name}}</td>
                                    <td>{{l.day}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="buddha-table-title">今日活动法会安排</div>
                    <div class="buddha-tale-box">
                        <table>
                            <thead>
                            <tr>
                                <th>名称</th>
                                <!--                                <th>时间</th>-->
                                <!--                                <th>地点</th>-->
                            </tr>
                            </thead>
                            <tbody v-if="buddhaData.actList.length > 0">
                            <tr :class="{back: i % 2 == 0}" v-for="(l, i) in buddhaData.actList" :key="i">
                                <td>{{l.name}}</td>
                                <!--                                <td>{{l.time}}</td>-->
                                <!--                                <td>{{l.place}}</td>-->
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="3">暂无</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="screen-piece">
                <router-link to="/hr/att" class="screen-piece-title">
                    <img src="../../screen/image/member-icon.png" class="piece-title-icon"/>
                    <div class="piece-title-text">人员签到</div>
                </router-link>
                <div class="member-data">
<!--                    <div class="member-data-item" :class="[`member-${i}`]" v-for="(m, i) in memberData" :key="i">-->
<!--                        <div class="member-data-chart">-->
<!--                            <div class="member-data-total">应到<span class="member-total-num" :style="{color: m.color}">{{m.num}}</span></div>-->
<!--                        </div>-->
<!--                        <div class="member-data-label">-->
<!--                            <div class="member-label-icon"></div>-->
<!--                            <div class="member-label-title">{{m.name}}</div>-->
<!--                        </div>-->
<!--                        <div class="member-data-num" v-if="i == 2">今日志工到岗</div>-->
<!--                    </div>-->
                    <div class="member-chart detail-link" id="member_chart"></div>
                </div>
            </div>
        </div>
        <div class="screen-mid">
            <div class="screen-mid-top">
                <div class="screen-piece-title">
                    <img src="../../screen/image/tourist-icon.png" class="piece-title-icon"/>
                    <div class="piece-title-text">游客统计</div>
                </div>
                <div class="mid-top-data">
                    <div class="mid-top-data-item">
                        <div class="mid-top-data-title">当前在寺人数</div>
                        <div class="mid-top-data-num" :class="getPersonNumClass(current)">
                            <span v-for="(n, j) in current + ''" :key="j">{{n}}</span>
                        </div>
                    </div>
                    <div class="mid-top-data-item">
                        <div class="mid-top-data-title">今日游客接待量</div>
                        <div class="mid-top-data-num">
                            <span v-for="(n, j) in dayNum + ''" :key="j">{{n}}</span>
                        </div>
                    </div>
                    <div class="tourist-chart-btn" @click="showChart"></div>
                    <tourist-chart :rs="data ? data.rs : undefined" :show="showArea == 'chart'" />
                </div>
            </div>
            <div class="weather-info" v-if="weather">
                <div class="weather-info-item">
                    <div class="weather-info-title">时间</div>
                    <div class="weather-info-text">：<time-clock show-seconds style="display:inline-block;"/></div>
                </div>
                <div class="weather-info-item">
                    <div class="weather-info-title">天气</div>
                    <div class="weather-info-text">：{{weather.text_day}}</div>
                </div>
                <div class="weather-info-item">
                    <div class="weather-info-title">温度</div>
                    <div class="weather-info-text">：{{weather.temperature}}°C</div>
                </div>
                <div class="weather-info-item">
                    <div class="weather-info-title">湿度</div>
                    <div class="weather-info-text">：{{weather.humidity * 1}}%</div>
                </div>
                <div class="weather-info-item">
                    <div class="weather-info-title">降水概率</div>
                    <div class="weather-info-text">：{{Math.round(weather.precip * 100)}}%</div>
                </div>
                <div class="weather-info-item">
                    <div class="weather-info-title">风力</div>
                    <div class="weather-info-text">：{{weather.wind_direction}}风 {{weather.wind_scale}}级 </div>
                </div>
                <div class="weather-info-item">
                    <div class="weather-info-title">空气质量</div>
                    <div class="weather-info-text">：{{weather.quality}}</div>
                </div>
            </div>
            <temple-video class="temple-map" :url="url" :points="mapPoint" :map-left="mapLeft" :map-top="mapTop" :class="{hide: showArea != 'map'}"></temple-video>
            <div class="mid-bottom">
                <div class="mid-bottom-area">
                    <div class="screen-piece-title">
                        <img src="../../screen/image/reception-icon.png" class="piece-title-icon"/>
                        <div class="piece-title-text detail-link" @click="goDetail('/temp/rec/data')">今日接待</div>
                    </div>
                    <div class="reception-data">
                        <div class="reception-data-item" :class="[`reception-${i}`]" v-for="(r, i) in receptionData"
                             :key="i">
                            <div class="reception-data-num">
                                <svg width="100px" height="100px" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <defs>
                                        <linearGradient :id="`wg_${i}_0`" x1="0%" x2="0%" y1="100%" y2="0%">
                                            <stop offset="0%" :stop-color="r.wave[0]" stop-opacity="1"/>
                                            <stop offset="100%" :stop-color="r.wave[1]" stop-opacity="1"/>
                                        </linearGradient>
                                        <linearGradient :id="`wg_${i}_1`" x1="0%" x2="0%" y1="100%" y2="0%">
                                            <stop offset="0%" :stop-color="r.wave[2]" stop-opacity="1"/>
                                            <stop offset="100%" :stop-color="r.wave[3]" stop-opacity="1"/>
                                        </linearGradient>
                                    </defs>
                                    <circle cx="50" cy="50" r="48" stroke-width="1" stroke-dasharray="5 2"
                                            :stroke="r.color" fill="transparent"></circle>
                                    <circle cx="50" cy="50" r="39" stroke-width="1" stroke="#c8effc"
                                            fill="transparent"></circle>
                                    <path stroke-width="3" :stroke="r.color" fill="none"
                                          d="M4.895 66.417 A48 48 0 0 0 95.105 66.417"></path>
                                    <!-- Wave -->
                                    <g :id="`wave_${i}`">
                                        <path :id="`wave_${i}_0`"
                                              fill-rule="evenodd"
                                              :fill="`url(#wg_${i}_0)`"
                                              d="M11.363 60.353 C40 80.353, 60 40.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z">
                                            <animate :dur="`${Math.random() * 3 + 1}s`"
                                                     :begin="`${Math.random() * 2}s`" repeatCount="indefinite"
                                                     attributeName="d" attributeType="XML"
                                                     values="M11.363 60.353 C40 80.353, 60 40.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z;
														M11.363 60.353 C40 40.353, 60 80.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z;
														M11.363 60.353 C40 60.353, 60 60.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z;
														M11.363 60.353 C40 80.353, 60 40.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z"></animate>
                                        </path>
                                        <path :id="`wave_${i}_1`"
                                              :begin="`${Math.random() * 3}s`"
                                              fill-rule="evenodd"
                                              :fill="`url(#wg_${i}_1)`"
                                              d="M11.363 60.353 C40 40.353, 60 80.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z">
                                            <animate :dur="`${Math.random() * 2 + 2}s`"
                                                     :begin="`${Math.random() * 2}s`" repeatCount="indefinite"
                                                     attributeName="d" attributeType="XML"
                                                     values="M11.363 60.353 C40 40.353, 60 80.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z;
														M11.363 60.353 C40 80.353, 60 40.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z;
														M11.363 60.353 C40 60.353, 60 60.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z;
														M11.363 60.353 C40 40.353, 60 80.353, 88.637 60.353 A40 40 0 0 1 11.363 60.353 Z"></animate>
                                        </path>
                                    </g>
                                    <text class="reception-num-text" text-anchor="middle" font-size="18px" x="50"
                                          y="44" font-weight="bold" style="fill: #fff">{{r.num}}
                                    </text>
                                </svg>
                            </div>
                            <div class="reception-data-title" :style="{color: r.color}">{{r.title}}</div>
                        </div>
                    </div>
                </div>
                <div class="mid-bottom-area">
                    <div class="screen-piece-title">
                        <img src="../../screen/image/epidemic-icon.png" class="piece-title-icon"/>
                        <div class="piece-title-text">疫情防控</div>
                    </div>
                    <div class="epidemic-btn" :class="{'show-line': showArea == 'yq'}" @click="showYqData"></div>
                    <div class="epidemic-table" v-show="showArea == 'yq'">
                        <table>
                            <thead>
                            <tr>
                                <th>时间</th>
                                <th>预警点位</th>
                                <th>体温</th>
                            </tr>
                            </thead>
                            <tbody v-if="oddList && oddList.length > 0">
                            <tr v-for="(item, i) in oddList" :key="i">
                                <td>{{item.time}}</td>
                                <td>{{item.position}}</td>
                                <td>{{item.temp}}</td>
                            </tr>
                            </tbody>
                            <tbody v-else-if="oddList">
                            <tr><td colspan="3" class="full">暂无异常记录</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="epidemic-data">
                        <svg width="316px" height="232px" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient id="gradient">
                                    <stop
                                      offset="0%"
                                      style="stop-color: #62c1f8;"
                                    />
                                    <stop
                                      offset="100%"
                                      style="stop-color: #5b31f3"
                                    />
                                </linearGradient>
                                <linearGradient id="radar" x1="0%" x2="100%" y1="100%" y2="0%">
                                    <stop offset="50%" stop-color="#63c2f9" stop-opacity="0"/>
                                    <stop offset="100%" stop-color="#63c2f9" stop-opacity="0.8"/>
                                </linearGradient>
                            </defs>
                            <g id="circle">
                                <circle cx="158" cy="122" r="109" stroke-width="1" stroke="#ffff94"
                                        fill="transparent"></circle>
                                <circle cx="158" cy="122" r="104" stroke-width="4" stroke="#ffff94"
                                        stroke-dasharray="3 2" fill="transparent"></circle>
                                <circle cx="158" cy="122" r="99" stroke-width="1" stroke="#ffff94"
                                        stroke-opacity="0.3"
                                        fill="transparent"></circle>
                                <path d="M158 32 V 122 H 68 A90 90 0 0 1 158 32" fill="url(#radar)">
                                    <animateTransform attributeName="transform" dur="5s" type="rotate" from="0 158 122" to="360 158 122" repeatCount="indefinite"/>
                                </path>
                                <image
                                  id="epidemic_mid" width="180" height="180"
                                  x="68" y="32"
                                  xlink:href="data:img/png;base64,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"/>
                                <path :d="epidemicData.path" stroke-width="13" stroke="url(#gradient)"
                                      stroke-linecap="round" fill="none" v-if="epidemicData.path"></path>
                            </g>
                            <g id="abnormal">
                                <circle cx="60" cy="57" r="3" fill="#ffff94"></circle>
                                <circle cx="16" cy="161" r="3" fill="#ffff94"></circle>
                                <path d="M57 57 H 16 V 158" stroke-width="1" stroke="#ffff94" fill="none"></path>
                                <text text-anchor="start" font-size="15px" x="0" y="187" font-weight="bold"
                                      style="fill: #ffff94">异常
                                </text>
                            </g>
                            <g id="normal">
                                <circle cx="293" cy="8" r="3" fill="#5fbaf8"></circle>
                                <circle cx="263" cy="175" r="3" fill="#5fbaf8"></circle>
                                <path d="M296 8 H 316 V 175 H 266" stroke-width="1" stroke="#5fbaf8"
                                      fill="none"></path>
                                <text text-anchor="start" font-size="15px" x="252" y="15" font-weight="bold"
                                      style="fill: #5fbaf8">正常
                                </text>
                            </g>
                            <g id="total">
                                <text text-anchor="middle" font-size="22px" x="158" y="122" font-weight="bold"
                                      style="fill: #fff">{{dayNum}}
                                </text>
                                <text text-anchor="middle" font-size="16px" x="158" y="150" font-weight="bold"
                                      style="fill: #9effe9">入寺人数
                                </text>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="screen-right">
            <div class="screen-piece">
                <div class="screen-piece-title">
                    <img src="../../screen/image/warn-icon.png" class="piece-title-icon"/>
                    <div class="piece-title-text">安全预警</div>
                </div>
                <div class="warn-data">
                    <div class="warn-data-item" v-for="(w, i) in warnData" :key="i">
                        <div class="warn-data-ctx" :class="{load: w.load, clickable: w.type}" @click="handleWarnClick(w)">
                            <img :src="w.icon" class="warn-data-icon">
                            <div class="warn-data-name">
                                <div class="warn-name-text">{{w.name}}</div>
                                <div class="warn-data-num" v-if="w.number">{{w.number}}</div>
                            </div>
                            <div class="warn-data-text">
                                <div class="warn-text-bar">
                                    <div class="warn-bar-len" :style="{width: w.width}"></div>
                                </div>
                                <div class="warn-text-title">{{w.load ? '接入中' : w.title}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="screen-piece">
                <div class="screen-piece-title">
                    <img src="../../screen/image/car-icon.png" class="piece-title-icon"/>
                    <div class="piece-title-text">入寺车辆</div>
                </div>
                <div class="park-data">
                    <div class="park-data-item">
                        <img src="../../screen/image/car-park.png" class="park-data-img">
                        <div class="park-data-title">今日报备车辆</div>
                        <div class="park-data-num">{{carData.left}}/{{carData.total}}</div>
                    </div>
                    <div class="park-data-item">
                        <img src="../../screen/image/car-enter.png" class="park-data-img">
                        <div class="park-data-title">入场车辆</div>
                        <div class="park-data-num">{{carData.enter}}</div>
                    </div>
                    <div class="park-data-item">
                        <img src="../../screen/image/car-out.png" class="park-data-img">
                        <div class="park-data-title">出场车辆</div>
                        <div class="park-data-num">{{carData.out}}</div>
                    </div>
                </div>
                <div class="car-park-record">
                    <div class="car-record-title">车辆出入</div>
                    <div class="buddha-tale-box">
                        <div class="buddha-table-tr back" :class="{'scroll-header': carData.recordList.length > 3}">
                            <div class="buddha-table-td buddha-table-th">时间</div>
                            <div class="buddha-table-td buddha-table-th">车牌号</div>
                            <div class="buddha-table-td buddha-table-th">门岗</div>
                            <div class="buddha-table-td buddha-table-th">状态</div>
                        </div>
                        <div class="car-record-list">
                            <div class="buddha-table-tr" :class="{back: i % 2 == 0}" v-for="(l, i) in carData.recordList" :key="i">
                                <div class="buddha-table-td">{{l.carAccessTime}}</div>
                                <div class="buddha-table-td">{{l.carNumber}}</div>
                                <div class="buddha-table-td">{{l.gate}}</div>
                                <div class="buddha-table-td">{{l.carAccessType == 1 ? "进场" : "离场"}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="screen-piece">
                <div class="screen-piece-title">
                    <img src="../../screen/image/opinion-icon.png" class="piece-title-icon"/>
                    <div class="piece-title-text">热点关注</div>
                </div>
                <div class="opinion-area">
                    <div class="opinion-type-list">
                        <div
                          class="opinion-type-item"
                          :style="{color: item.color}"
                          v-for="(item, i ) in analysis"
                          :key="i">{{item.title}} {{item.num}}</div>
                    </div>
                </div>
                <opinion-data :list="opinionList" :total="opinionTotal"></opinion-data>
            </div>
        </div>
        <div class="plaque-modal" v-show="showArea == 'plaque'">
            <div class="plaque-modal-title">牌匾异常告警！</div>
            <div class="plaque-modal-text">设备名称：图书馆</div>
            <div class="plaque-modal-text">角度值：2°</div>
            <div class="plaque-modal-btn" @click="hidePlaqueModal">确认</div>
            <div class="plaque-modal-close" @click="hidePlaqueModal">
                <a-icon type="close"/>
            </div>
        </div>
    </div>
</template>

<script>
    import 'videojs-contrib-hls'
    import 'video.js/dist/video-js.css'
    import * as echarts from 'echarts';
    import timeClock from "./graph/time-clock";
    // import member from "../../screen/member";
    import getAttendanceOptions from "../../screen/attendance";
    import { mapPoint, baseOption } from "../../screen/templeVideo";
    import TempleVideo from "./TempleVideo";
    import {getDate, getPoint} from "../../common/js/tool";
    import {opinionTypeList} from "../../screen/safety/data/opinion";
    import opinionData from "./graph/opinion-data";
    import touristChart from "./graph/tourist-chart";

    const LEVEL_ONE_NUMBER = 19000;
    const WARNING_ONE_NUMBER = 17000;
    const LEVEL_TWO_NUMBER = 12000;
    const WARNING_TWO_NUMBER = 10000;
    const LEVEL_THREE_NUMBER = 8000;
    const WARNING_THREE_NUMBER = 6000;

    export default {
        name: "Complex",
        components: {
            TempleVideo,
            timeClock,
            opinionData,
            touristChart
        },
        props: {
            data: Object,
            count: Object,
        },
        data() {
            return {
                current: 0,
                dayNum: 0,
                showArea: 'map',
                weather: null,
                approveData: {
                    total: 0,
                    prev: 0,
                    nw: '48px',
                    topList: []
                },
                buddhaData: {
                    total: 0,
                    prev: 0,
                    noticeList: [
                        [
                            // {name: '中秋节', date: '2022-09-10'},
                            // {name: '国庆节', date: '2022-10-01'},
                            // {name: '重阳节', date: '2022-10-04'},
                            // {name: '元旦节', date: '2023-01-01'},
                        ],
                        [
                            // {name: '华严法会', date: '2022-05-15', end: '2022-08-12', place: '药师殿'},
                            // {name: '盂兰盆法会', date: '2022-08-12'},
                            // {name: '地藏法会', date: '2022-08-18'},
                            // {name: '水陆法会', date: '2022-10-08'},
                            // {name: '佛陀成道日', date: '2022-12-30'},
                        ]
                    ],
                    actList: [
                        // {name: '大型法会', time: '8:00-12:00', place: '大雄宝殿'},
                        // {name: '大型法会', time: '13:00-14:00', place: '天王殿'},
                        // {name: '大型法会', time: '15:00-16yarn:00', place: '药师殿'},
                    ]
                },
                memberData: [
                    {name: '僧众', color: '#96fcb0', num: 0},
                    {name: '职工', color: '#f5df8e', num: 0},
                    {name: '志工', color: '#a2dff3', num: 0},
                ],
                warnData: [
                    {name: '烟感', title: '正常', width: '85%', icon: require('../../screen/image/warn-smoke.png'), type: 1},
                    {name: '水压', title: '正常', width: '80%', icon: require('../../screen/image/warn-water.png'), type: 2},
                    {name: '电力', title: '正常', width: '82%', icon: require('../../screen/image/warn-power.png'), type: 3},
                    {name: '山体', title: '正常', width: '90%', icon: require('../../screen/image/warn-hill.png'), type: 7},
                    {name: '牌匾', title: '正常', width: '50%', icon: require('../../screen/image/plaque.png'), type: 6},
                    {name: '围栏', title: '暂无', width: '63%', icon: require('../../screen/image/warn-fence.png'), load: true}
                ],
                carData: {
                    total: 0,
                    left: 0,
                    enter: 0,
                    out: 0,
                    recordList: []
                },
                words: [
                    {word: '宗教界人士'},
                    {word: '灵隐景区'},
                    {word: '和尚'},
                    {word: '戒律'},
                    {word: '法师'},
                    {word: '灵隐寺'},
                    {word: '出家人'},
                    {word: '法会'},
                    {word: '祈福'},
                    {word: '杭州佛教'},
                    {word: '飞来峰'},
                    {word: '寺院'},
                    {word: '灵隐'},
                ],
                analysis: [],
                mapLeft: 82,
                mapTop: 76,
                url: require("../../screen/image/temple.png"),
                mapPoint,
                epidemicData: {
                    total: 10658,
                    abnormal: 32
                },
                receptionData: [
                    {
                        title: '接待人数',
                        num: 0,
                        color: '#46ddbb',
                        wave: ['rgb(113,231,244)', 'rgb(43,183,151)', 'rgb(65,219,184)', 'rgb(156,255,233)']
                    },
                    {
                        title: '上香',
                        num: 0,
                        color: '#4e90d2',
                        wave: ['rgb(113,231,244)', 'rgb(58,118,180)', 'rgb(63,116,239)', 'rgb(89,229,197)']
                    },
                    {
                        title: '会议室',
                        num: '0/0',
                        color: '#529df8',
                        wave: ['rgb(113,231,244)', 'rgb(58,118,180)', 'rgb(63,116,239)', 'rgb(117,231,248)']
                    },
                    {
                        title: '用餐',
                        num: 0,
                        color: '#8175f8',
                        wave: ['rgb(113,231,244)', 'rgb(95,84,209)', 'rgb(106,95,214)', 'rgb(168,159,255)']
                    },
                    {
                        title: '客房',
                        num: '0/76',
                        color: '#ffe895',
                        wave: ['rgb(113,231,244)', 'rgb(248,217,120)', 'rgb(246,221,141)', 'rgb(254,255,228)']
                    },
                    {
                        title: '车辆',
                        num: 0,
                        color: '#3a36f5',
                        wave: ['rgb(31,28,177)', 'rgb(56,51,245)', 'rgb(56,50,245)', 'rgb(139,196,255)']
                    },
                ],
                plaqueData: {
                    status: 1,
                    angle: 0
                },
                oddList: [],
                options: null,
                vs: false,
                videoStyle: null,
                opinionTotal: 0,
                opinionList: [],
            }
        },
        computed: {
            opinionData() {
                const d = this.opinionList[this.opinionTab];
                return d && d.data ? d.data : [];
            }
        },
        watch: {
            data() {
                this.setData();
            },
            count() {
                this.setCount();
            }
        },
        mounted() {
            this.setWordsData();
            this.setData();
            this.setCount();
            document.addEventListener("click", this.hideVideo, false)
        },
        beforeDestroy() {
            document.removeEventListener("click", this.hideVideo, false)
        },
        methods: {
            handleWarnClick(w) {
                if(w.type) {
                    this.$emit("safety", w.type);
                }
            },
            getPersonNumClass(num) {
                let res = [];
                if(num > LEVEL_ONE_NUMBER) {
                    res = ['top-data-danger']
                } else if(num > LEVEL_TWO_NUMBER) {
                    res = ['top-data-warning']
                } else if(num > LEVEL_THREE_NUMBER) {
                  res = ['top-data-tip']
                }
                return res;
            },
            showPlaqueModal() {
                this.showArea = 'plaque';
            },
            hidePlaqueModal() {
                this.showArea = 'map';
            },
            goDetail(path) {
                window.open(path, '_blank')
            },
            videoEnter() {
                this.videoTimer && clearTimeout(this.videoTimer)
            },
            pointEnter(e, m) {
                if(m.video) {
                    if(!this.options || this.options.sources[0].src != m.video) {
                        this.options = Object.assign(baseOption, {
                            sources: [{
                                type: "application/x-mpegURL",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                                src: m.video//url地址
                            }],
                        });
                        this.videoStyle = {
                            top: this.mapTop + m.top + "px",
                            left: this.mapLeft + m.left + "px"
                        }
                    }
                    this.vs = true;
                }
            },
            pointLeave() {
                // this.videoTimer = setTimeout(() => {
                //   this.vs = false;
                // }, 300)
            },
            hideVideo() {
                this.vs = false;
            },
            showYqData() {
                if(this.showArea == 'yq') {
                    this.showArea = 'map';
                } else {
                    this.showArea = 'yq';
                }
            },
            showChart() {
                if(this.showArea == 'chart') {
                    this.showArea = 'map';
                } else {
                    this.showArea = 'chart';
                }
            },
            setCount() {
                const count = this.count;
                if(count) {
                    this.current = count.now;
                    this.dayNum = count.all;
                }
            },
            setData() {
                let res = this.data;
                if(res) {
                    this.setTop(res);
                    this.setAnalysis(res.newYq);
                    this.setApproveData(res.sp);
                    this.setBuddhaData(res);
                    this.setReceptionData(res.jrjd);
                    this.setEpidemicData();
                    this.setMemberData(res);
                    this.setPlaqueData(res);
                    this.setNumberData(res);
                    this.setCarData(res);
                }
            },
            setNumberData(res) {
                if(res.rs) {
                  // this.current = res.rs.now;
                  // this.dayNum = res.rs.all;
                  // this.current = 12262;
                  let waring = null, notice = null;
                  if(this.current > LEVEL_ONE_NUMBER) {
                    waring = {
                      id: 'warning_one',
                      title: '在寺人数一级预警',
                      text: `当前在寺人数${this.current}人`,
                      type: 'danger',
                      audio: 'warning_one'
                    }
                  } else if(this.current > WARNING_ONE_NUMBER) {
                    notice = {
                      id: 'number_one',
                      title: '在寺人数预警：',
                      text: '人流容积接近一级响应触发条件，请检查一级响应工作内容。',
                      type: 'danger',
                      audio: 'number_one'
                    }
                  } else if(this.current > LEVEL_TWO_NUMBER) {
                    waring = {
                      id: 'warning_two',
                      title: '在寺人数二级预警',
                      text: `当前在寺人数${this.current}人`,
                      type: 'warning',
                      audio: 'warning_two'
                    }
                  } else if(this.current > WARNING_TWO_NUMBER) {
                    notice = {
                      id: 'number_two',
                      title: '在寺人数预警：',
                      text: '人流容积接近二级响应触发条件，请检查二级响应工作内容。',
                      type: 'warning',
                      audio: 'number_two'
                    }
                  } else if(this.current > LEVEL_THREE_NUMBER) {
                    waring = {
                      id: 'warning_three',
                      title: '在寺人数三级预警',
                      text: `当前在寺人数${this.current}人`,
                      type: 'tip',
                      audio: 'warning_three'
                    }
                  } else if(this.current > WARNING_THREE_NUMBER) {
                    notice = {
                      id: 'number_three',
                      title: '在寺人数预警：',
                      text: '人流容积接近三级响应触发条件，请检查三级响应工作内容。',
                      type: 'tip',
                      audio: 'number_three'
                    }
                  }
                  this.$emit("waring", waring);
                  this.$emit("notice", notice);
                }
            },
            setPlaqueData(data) {
                let plaque = data.pb;
                if(plaque) {
                    let item = this.warnData.find(w => w.name == '牌匾');
                    const angle = Math.round(plaque.angle / 10);
                    this.$set(item, 'number', angle);
                    this.$set(this.plaqueData, 'angle', angle);
                    this.$set(this.plaqueData, 'status', plaque.is_normal);
                    if(plaque.is_normal == 1) {
                        this.$set(item, 'title', '正常');
                        if(this.showArea == 'plaque') {
                            this.hidePlaqueModal();
                        }
                    } else {
                        this.showPlaqueModal();
                        this.$set(item, 'title', '异常');
                    }
                }
                const power = data.power;
                if(power) {
                    const item = this.warnData.find(w => w.name == '电力');
                    let warning = null, title = '正常';
                    if(power.error != 0) {
                        warning = {
                            id: 'power_warning',
                            title: '电力告警',
                            text: '电力异常',
                            type: 'danger'
                        }
                        title = '异常';
                    }
                    this.$emit("waring", warning);
                    this.$set(item, 'title', title);
                }
            },
            setReceptionData(data) {
                let temp = this.receptionData;
                temp[0].num = data.jd;
                temp[1].num = data.sx;
                temp[2].num = data.hys ? `${data.hys.yys}/${data.hys.zs}` : '0/0';
                temp[3].num = data.yc;
                temp[5].num = data.cl;
            },
            setCarData(res) {
                const data = res.tcjl;
                if(data) {
                    const carData = {...this.carData};
                    if(data.count) {
                        carData.total = data.count[0] || 0;
                        carData.left = data.count[1] || 0;
                        carData.enter = data.count[2] || 0;
                        carData.out = data.count[3] || 0;
                    }
                    if(data.record) {
                        data.record.forEach(item => {
                            item.gate = ['第一道岗', '第二道岗', '第三道岗'][item.position - 1];
                        })
                        carData.recordList = data.record;
                    }
                    this.carData = carData;
                }
            },
            setMemberData(res) {
                const attendance = getAttendanceOptions(res);
                if(!this.memberChart) {
                    this.memberChart = echarts.init(document.getElementById('member_chart'));
                }
                this.memberChart.setOption(attendance);
            },
            setBuddhaData({calData, fsData}) {
                let today = new Date();
                today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                let total = 0, prev = 0;
                let todayList = [], act = [], fs = [];
                if(calData) {
                    let day = 24 * 60 * 60 * 1000;
                    todayList = calData.filter(sch => sch.status == 0 && today.getTime() < sch.end_time * 1000 && sch.start_time * 1000 <= today.getTime() + day);
                    let actList = calData.filter(sch => sch.status == 0 && today.getTime() < sch.end_time * 1000 && sch.start_time * 1000 > today.getTime() + day);
                    actList.sort((a, b) => a.start_time - b.start_time);
                    total = actList.length + todayList.length;
                    let temp = actList.slice(0, 10).map(sch => {
                        let sd = new Date(sch.start_time * 1000).pattern("yyyy-MM-dd");
                        return {name: sch.summary, day: this.getOffsetDay(today, sd)}
                    });
                    todayList = todayList.map(sch => {return {name: sch.summary}});
                    act = temp.slice(0, 5);
                    fs = temp.slice(5, 10);
                }
                if(fsData && fsData.fh) {
                    prev = fsData.fh.count;
                }
                let n = null;
                if(act.length > 0) {
                    n = act[0];
                }
                if(fs.length > 0) {
                    if(!n || (n && n.day > fs[0].day)) {
                        n = fs[0];
                    }
                }
                if(n) {
                    this.$emit("remind", `距离${n.name}还有${n.day}天`);
                }
                this.buddhaData = {
                    total,
                    prev,
                    noticeList: [act, fs],
                    actList: todayList.slice(0, 2)
                }
            },
            getOffsetDay(today, date) {
                let one = 24 * 60 * 60 * 1000;
                date = getDate(`${date} 00:00:00`);
                let offset = Math.round((date.getTime() - today.getTime()) / one);
                return offset < 0 ? 0 : offset;
            },
            setAnalysis(yq) {
                const list = [...opinionTypeList];
                if(yq && yq.count) {
                    list.forEach((item, i) => item.num = yq.count[i] || 0);
                    this.opinionTotal = yq.count[3];
                }
                this.analysis = list;
                this.opinionList = yq.chart;
            },
            setTop({lunar, weather, air}) {
                this.$emit("lunar", lunar);
                if(weather) {
                    if(air) {
                        weather.quality = air.quality;
                    }
                    this.weather = weather;
                }
            },
            setWordsData() {
                let words = this.words;
                let ss = [1, 0.66, 0.5];
                words.forEach(w => {
                    if (w.word.length <= 3) {
                        let scale = ss[Math.round(Math.random() * (ss.length - 1))];
                        w.padding = `${scale * 6}px`;
                        w.width = `${scale * 50}px`;
                        w.scale = scale;
                    }
                    this.$set(w, 'className', `word-${Math.round(Math.random() * 6)}`);
                });
            },
            setApproveData(data) {
                let list = data.list;
                this.$set(this.approveData, 'total', data.ysp);
                this.$set(this.approveData, 'prev', data.wsp);
                list.sort((a, b) => {
                    return b.count - a.count;
                })
                if (list && list.length > 0) {
                    let max = list[0].count * 1;
                    list.forEach(item => {
                        item.width = (item.count / max * 100) + '%';
                    });
                    this.$set(this.approveData, 'nw', (max + '').length + 'em');
                    this.$set(this.approveData, 'topList', list);
                }
            },
            setEpidemicData() {
                let {total, abnormal} = this.epidemicData;
                let min = 20; // 最小角度
                let start = 145; // 起始位置
                let angle = Math.round(abnormal / total * 360);
                angle = angle < min ? min : angle;
                let p1 = getPoint(158, 122, 104, start - angle / 2);
                let p2 = getPoint(158, 122, 104, start + angle / 2);
                let path = `M${p1.x} ${p1.y} A104 104 0 ${angle > 180 ? 0 : 1} 1 ${p2.x} ${p2.y}`;
                this.$set(this.epidemicData, 'path', path);
            },
        }
    }
</script>

<style scoped lang="less">
    @import "../../screen/screen";
    .screen {
        display: flex;
        padding: 80px 32px 30px;
    }

    .screen-banner {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 125px;
        background: url(../../screen/image/top.png) center no-repeat;
        background-size: contain;
    }
    .screen-left,
    .screen-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px;
        width: 428px;
        background: url(../../screen/image/border.png) center no-repeat;
        background-size: 100% 100%;
    }

    .screen-mid {
        flex: 1;
        position: relative;
        padding: 30px 40px 0;
    }

    .approve-data-list {
        margin-top: 16px;
    }

    .list-title {
        display: flex;
        align-items: center;
    }

    .list-title-icon {
        position: relative;
        width: 16px;
        height: 16px;
        border-radius: 100%;
        border: 1px solid #7bf7ac;

        &::after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 8px;
            height: 8px;
            border-radius: 100%;
            background-color: #7bf7ac;
        }
    }

    .list-title-text {
        margin-left: 4px;
        font-size: 14px;
        font-weight: bold;
    }

    .data-list-area {
        margin-top: 10px;
        padding-left: 20px;
    }

    .data-list-item {
        display: flex;
        align-items: center;
        font-size: 12px;

        &:not(:first-child) {
            margin-top: 5px;
        }
    }

    .data-list-title {
        width: 64px;
    }

    .data-list-num {
        flex: 1;
        display: flex;
        align-items: center;
        position: relative;
        height: 18px;

        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: linear-gradient(to right, rgba(164, 225, 244), rgba(88, 138, 247));
            opacity: .2;
        }
    }

    .data-num-bar {
        position: relative;
        height: 12px;

        &.bar-0 {
            background-image: linear-gradient(to right, #a4e1f4, #588af7);
        }

        &.bar-1 {
            background-image: linear-gradient(to right, #6f9bf8, #416bc7);
        }

        &.bar-2 {
            background-image: linear-gradient(to right, #a9a0f8, #7a6df6);
        }

        &.bar-3 {
            background-image: linear-gradient(to right, #b6fdd6, #95fcae);
        }

        &.bar-4 {
            background-image: linear-gradient(to right, #f9ffab, #f3b166);
        }
    }

    .data-num-text {
        position: relative;
        padding: 0 10px;
        box-sizing: content-box;
        text-align: center;
    }

    .buddha-area {
        margin-top: 22px;
        padding-left: 10px;
    }

    .buddha-data {
        display: flex;
        font-weight: bold;
    }

    .buddha-data-item {
        flex: 1;
        display: flex;
        align-items: center;

        &:not(:first-child) {
            margin-left: 16px;
        }
    }

    .buddha-data-num {
        margin-left: 6px;
        padding: 0 10px;
        height: 24px;
        background-color: rgba(110, 169, 233, .2);
        border: 1px solid #6ea9e9;
        border-radius: 6px;
        font-size: 20px;
        font-weight: 700;
        line-height: 22px;
        color: #92fcfd;
    }

    .buddha-table-title {
        margin: 6px 0;
        font-weight: bold;
    }

    .buddha-notice-area {
        display: flex;

        .buddha-tale-box {
            flex: 1;

            &:not(:first-child) {
                margin-left: 16px;
            }
        }
    }

    .buddha-tale-box {
        text-align: center;
        font-size: 12px;
        line-height: 28px;

        table {
            width: 100%;
        }

        th {
            background-color: rgba(56, 128, 211, .5);
            color: #92fcfd;
        }

        tr {
            background-color: rgba(56, 128, 211, .1);

            &.back {
                background-color: rgba(56, 128, 211, .25);
            }
        }
        td, th {
            padding: 0 4px;
            max-width: 90px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }

    .buddha-table-tr {
        display: flex;
        align-items: center;
        background-color: rgba(56, 128, 211, .1);
        &.back {
            background-color: rgba(56, 128, 211, .25);
        }
    }

    .buddha-table-td {
        flex: 1;
        padding: 0 4px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.buddha-table-th {
            background-color: rgba(56, 128, 211, .5);
            color: #92fcfd;
        }
    }
    .car-carousel {
        height: 84px;
    }
    .car-park-record {
        .buddha-table-td {
            &:first-of-type  {
                flex: none;
                width: 40%;
            }
            &:last-of-type {
                flex: none;
                width: 15%;
            }
        }
        .scroll-header {
            padding-right: 4px;
        }
    }
    .member-data {
        margin: 12px 0 0;
    }
    .member-chart {
        height: 200px;
    }
    .member-data-item {
        flex: 1;
        &.member-0 {
            .member-label-icon {
                background-color: #96fcb0;
            }
        }

        &.member-1 {
            .member-label-icon {
                background-color: #f5df8e;
            }
        }

        &.member-2 {
            .member-label-icon {
                background-color: #a2dff3;
            }
        }
    }

    .member-data-chart {
        position: relative;
        height: 130px;
    }
    .member-data-total {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color: #fff;
        font-size: 12px;
        text-align: center;
        .member-total-num {
            font-size: 16px;
            font-weight: 900;
            letter-spacing: 0.035em
        }
    }
    .member-chart-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .member-data-label {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
    }

    .member-label-icon {
        margin-right: 6px;
        width: 13px;
        height: 8px;
        border-radius: 2px;
    }
    .member-data-num {
        margin-top: 6px;
        text-align: center;
        font-size: 12px;
    }
    .warn-data {
        margin: 0 -6px;
        font-size: 0;
    }

    .warn-data-item {
        display: inline-block;
        margin-top: 20px;
        padding: 6px;
        width: 33.33333333%;
        font-size: 14px;
        font-weight: bold;
    }

    .warn-data-ctx {
        position: relative;
        padding-top: 50px;
        height: 92px;
        background: url(../../screen/image/warn-back.png) center no-repeat;
        background-size: 100% 100%;
        &.load {
            .warn-data-text {
                justify-content: center;
            }
            .warn-text-bar {
                display: none;
            }
        }
        &.clickable {
            cursor: pointer;
        }
    }

    .warn-data-icon {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 76px;
        margin: 0 auto;
    }

    .warn-data-name {
        display: flex;
        justify-content: center;
        text-align: center;
    }
    .warn-data-num {
        margin-left: 24px;
    }

    .warn-data-text {
        display: flex;
        align-items: center;
        margin: 6px 6px 0;
        height: 18px;
        background-color: rgba(26, 44, 97, .2);
        font-size: 12px;
    }

    .warn-text-bar {
        flex: 1;
    }

    .warn-bar-len {
        height: 12px;
        background-image: linear-gradient(to left, #f9ffab, #f3b166);
    }

    .warn-text-title {
        padding: 0 4px;
    }

    .park-data {
        display: flex;
        margin-top: 6px;
    }

    .park-data-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .park-data-title {
        margin-top: 6px;
        font-size: 14px;
        font-weight: bold;
    }

    .park-data-num {
        margin-top: 6px;
        padding: 0 10px;
        height: 24px;
        background-color: rgba(110, 169, 233, .2);
        border: 1px solid #6ea9e9;
        border-radius: 6px;
        font-size: 20px;
        font-weight: 700;
        line-height: 22px;
        color: #92fcfd;
    }

    .car-record-title {
        margin: 20px 0 10px;
    }

    .car-record-list {
        height: 84px;
        overflow: auto;
        &::-webkit-scrollbar {
            width: 4px;
            height: 10px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #66FFFF;
            border-radius: 4px;
            cursor: pointer;
        }
    }

    .opinion-area {
        display: flex;
        margin-top: 12px;
    }
    .opinion-area-title {
        font-size: 14px;
        font-weight: bold;
    }
    .opinion-type-list {
        display: flex;
        align-items: center;
        padding: 6px 12px;
        width: 100%;
        border-radius: 4px;
        border: 1px solid #5BAEF2;
        background: #12285E;
    }
    .opinion-type-item {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
    }
    .opinion-word-list {
        margin: 20px auto 0;
        width: 200px;
        height: 200px;
    }
    .opinion-words {
        flex: 1;
        height: 238px;
    }
    .opinion-word-ball {
        position: relative;
        width: 200px;
        height: 200px;
    }
    .opinion-word-item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin: 2px;
        padding: 6px;
        width: 50px;
        height: 50px;
        font-size: 12px;
        font-weight: bold;
        line-height: 1.2;
        text-align: center;
    }

    .opinion-word-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 100%;
        border: 1px solid #4180ea;

        &.word-1 {
            border-color: #79fff1;
        }

        &.word-2 {
            border-color: #d8a5ff;
        }

        &.word-3 {
            border-color: #f8ef9d;
        }

        &.word-4 {
            border-color: #fc8080;
        }

        &.word-5 {
            border-color: #4a51f7;
        }

        &.word-6 {
            border-color: #f59b7c;
        }
    }

    .opinion-analysis {
        padding: 0 12px;
    }
    .opinion-analysis-list {
        margin-top: 60px;
    }
    .analysis-item {
        display: flex;
        align-items: center;
        margin-top: 10px;
        padding-left: 24px;
        width: 133px;
        height: 33px;
        background: url(../../screen/image/analysis-back.png);
        font-size: 12px;
    }

    .analysis-title {
        font-weight: bold;
    }

    .analysis-num {
        margin-left: 30px;
        color: #92fcfd;
    }

    .mid-top-data {
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 90px;
        left: 40px;
        right: 40px;
        z-index: 1;
    }

    .mid-top-data-item {
        display: flex;
        font-size: 16px;
        font-weight: bold;
    }

    .mid-top-data-title {
        margin-right: 12px;
        padding: 10px 0;
    }

    .mid-top-data-num {
        font-size: 40px;
        line-height: 44px;
        text-align: center;
        color: #88f5ff;
        &.top-data-tip {
            color: #fee28f;
            span {
                border-color: rgba(254,226,143,.8);
                background-color: rgba(254,226,143,.2);
            }
        }
        &.top-data-warning {
            color: #f87141;
            span {
              border-color: rgba(248,113,65,.8);
              background-color: rgba(248,113,65,.2);
            }
        }
        &.top-data-danger {
            color: #d93327;
            span {
                border-color: rgba(217,51,39,.8);
                background-color: rgba(217,51,39,.2);
            }
        }
        span {
            display: inline-block;
            width: 44px;
            height: 48px;
            border-radius: 6px;
            border: 2px solid #6ea9e9;
            background-color: rgba(110, 169, 233, .2);

            &:not(:first-of-type) {
                margin-left: 6px;
            }
        }
    }

    .tourist-chart-btn {
        margin-top: 12px;
        width: 163px;
        height: 26px;
        background: url(../../screen/image/chart-btn.png) center no-repeat;
        background-size: contain;
        cursor: pointer;
    }

    .weather-info {
        position: absolute;
        top: 170px;
        left: 40px;
    }

    .weather-info-item {
        display: flex;
        align-items: center;
        margin-top: 10px;
        font-weight: bold;
        font-size: 16px;
    }

    .weather-info-title {
        color: #7af9f9;
    }

    .temple-map {
        position: relative;

        &.hide {
            visibility: hidden;
        }
    }

    .mid-bottom {
        display: flex;
        position: absolute;
        left: 40px;
        right: 40px;
        bottom: 0;
    }

    .mid-bottom-area {
        flex: 1;
    }

    .epidemic-btn {
        position: relative;
        margin-top: 20px;
        width: 117px;
        height: 26px;
        background: url(../../screen/image/yq-btn.png) center no-repeat;
        background-size: contain;
        cursor: pointer;
        &.show-line {
            &::after,
            &::before {
                content: '';
                display: block;
            }
        }
        &::after,
        &::before {
            content: '';
            display: none;
            position: absolute;
            background-color: #75fbfd;
        }
        &::before {
            content: '';
            top: 0;
            right: 4px;
            bottom: 0;
            margin: auto 0;
            width: 160px;
            height: 2px;
            transform: translateX(100%);
        }
        &::after {
            content: '';
            right: -156px;
            bottom: 12px;
            width: 2px;
            height: 136px;
            background-color: #75fbfd;
        }
    }
    .epidemic-data {
        margin-top: 12px;
        padding-left: 60px;
    }
    .epidemic-table {
        position: absolute;
        top: -60px;
        left: 0;
        right: 0;
        margin: 0 auto;
        padding: 96px 60px 36px;
        width: 696px;
        height: 397px;
        background: url(../../screen/image/yq-border.png) center no-repeat;
        background-size: contain;
        transform: translateY(-100%);
        z-index: 2;
        table {
            width: 100%;
            font-size: 16px;
            text-align: center;
        }
        td, th {
            padding: 12px 0;
            width: 33.33333333%;
            border: 2px solid #75fbfd;
        }
        td.full {
            padding: 80px 0;
        }
        th {
            font-size: 20px;
            font-weight: 600;
            color: #fff2c4;
            font-style: italic;
        }
    }

    .reception-data {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .reception-data-item {
        margin-top: 18px;
        width: 33.333333%;
        text-align: center;
    }

    .reception-data-title {
        margin-top: 6px;
        font-size: 14px;
        font-weight: bold;
    }
    .plaque-modal {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        padding: 23px;
        width: 449px;
        height: 313px;
        background: url(../../screen/image/plaque-modal.png) center / contain no-repeat;
        transform: translateY(-30%);
        text-align: center;
        font-weight: 600;
    }
    .plaque-modal-title {
        margin: 46px 0 22px;
        font-size: 40px;
        color: #f8f09e;
        text-shadow: 0 4px 5px rgba(0,40,122,.5);
    }
    .plaque-modal-text {
        margin-top: 12px;
        font-size: 22px;
        color: #fff;
    }
    .plaque-modal-btn {
        margin: 28px auto 0;
        width: 98px;
        height: 26px;
        background-color: #f8f09e;
        border-radius: 4px;
        line-height: 26px;
        font-size: 18px;
        color: #0a182f;
        cursor: pointer;
    }
    .plaque-modal-close {
        position: absolute;
        top: 35px;
        right: 32px;
        width: 28px;
        height: 28px;
        border-radius: 100%;
        background-color: #ff6969;
        font-size: 16px;
        text-align: center;
        line-height: 28px;
        color: #0a182f;
        cursor: pointer;
    }
</style>
